import { RespuestaLecturaError } from '../Mensajes';
import { llamadaAPI_GET, llamadaAPI_POST, llamadaAPI_PUT } from '../SQL';
import { FormateoFechaPara_yyyyMMdd, TratamientoDeParametroParaURI } from '../Varios';

export const function_CON_Cheques_Listar = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_CON_Cheques_Listar"

    try {
        const resulData = await llamadaAPI_GET("CON_Cheques/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CON_Cheques_ListarDeTercerosUsables = async () => {
    const NombreFuncion = "function_CON_Cheques_ListarDeTercerosUsables"

    try {
        const resulData = await llamadaAPI_GET("CON_Cheques/ListarDeTercerosUsables/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta"));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CON_Cheques_Acreditar = async (IdCheque, Fecha) => {
    const NombreFuncion = "function_CON_Cheques_Acreditar";

    try {
        await llamadaAPI_PUT("CON_Cheques/Acreditar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdCheque + "/" +
            await FormateoFechaPara_yyyyMMdd(new Date(Fecha)));
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_CON_Cheques_Depositar = async (IdCheque, Fecha, CodigoCuentaFinancieraDeposito) => {
    const NombreFuncion = "function_CON_Cheques_Depositar";

    try {
        await llamadaAPI_PUT("CON_Cheques/Depositar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdCheque + "/" +
            await FormateoFechaPara_yyyyMMdd(new Date(Fecha)) + "/" +
            await TratamientoDeParametroParaURI(CodigoCuentaFinancieraDeposito));
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_CON_Cheques_Debitar = async (IdCheque, Fecha) => {
    const NombreFuncion = "function_CON_Cheques_Debitar";

    try {
        await llamadaAPI_PUT("CON_Cheques/Debitar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdCheque + "/" +
            await FormateoFechaPara_yyyyMMdd(new Date(Fecha)));
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_CON_Cheques_Negociar = async (IdCheque, Fecha, CodigoCuentaFinancieraDeposito, ImporteComision) => {
    const NombreFuncion = "function_CON_Cheques_Negociar";

    try {
        await llamadaAPI_PUT("CON_Cheques/Negociar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdCheque + "/" +
            await FormateoFechaPara_yyyyMMdd(new Date(Fecha)) + "/" +
            await TratamientoDeParametroParaURI(CodigoCuentaFinancieraDeposito) + "/" +
            ImporteComision);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_CON_Cheques_Rechazar = async (IdCheque, Fecha) => {
    const NombreFuncion = "function_CON_Cheques_Rechazar";

    try {
        await llamadaAPI_PUT("CON_Cheques/Rechazar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdCheque + "/" +
            await FormateoFechaPara_yyyyMMdd(new Date(Fecha)));
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_CON_Cheques_Reemplazar = async (IdCheque, Fecha, Banco, Numero, FechaCompromiso, Importe) => {
    const NombreFuncion = "function_CON_Cheques_Reemplazar";

    try {
        await llamadaAPI_PUT("CON_Cheques/Reemplazar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdCheque + "/" +
            await FormateoFechaPara_yyyyMMdd(new Date(Fecha)) + "/" +
            await TratamientoDeParametroParaURI(Banco) + "/" +
            await TratamientoDeParametroParaURI(Numero) + "/" +
            await FormateoFechaPara_yyyyMMdd(new Date(FechaCompromiso)) + "/" +
            Importe);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_CON_Cheques_Editar = async (IdCheque, IdPago, IdRecibo, CodigoCuentaFinancieraOrigen,
    CodigoCuentaFinancieraDeposito, Numero, FechaEmision, FechaPagoCompromiso, FechaDeposito, FechaCobro,
    FechaRechazo, Banco, Importe, IdEstado, ImporteCobrado, ImporteComision, Cuenta, CUIT, Direccion,
    RazonSocial, DomicilioPago, RazonSocial_Origen, FechaAdjudicacion, AdjudicacionDestino, AdjudicacionReferencia) => {
    const NombreFuncion = "function_CON_Cheques_Editar";

    try {
        await llamadaAPI_PUT("CON_Cheques/Editar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdCheque + "/" +
            IdPago + "/" +
            IdRecibo + "/" +
            await TratamientoDeParametroParaURI(CodigoCuentaFinancieraOrigen) + "/" +
            await TratamientoDeParametroParaURI(CodigoCuentaFinancieraDeposito) + "/" +
            await FormateoFechaPara_yyyyMMdd(new Date(FechaEmision)) + "/" +
            await FormateoFechaPara_yyyyMMdd(new Date(FechaPagoCompromiso)) + "/" +
            await FormateoFechaPara_yyyyMMdd(new Date(FechaDeposito)) + "/" +
            await FormateoFechaPara_yyyyMMdd(new Date(FechaCobro)) + "/" +
            await FormateoFechaPara_yyyyMMdd(new Date(FechaRechazo)) + "/" +
            await TratamientoDeParametroParaURI(Banco) + "/" +
            Importe + "/" +
            IdEstado + "/" +
            ImporteCobrado + "/" +
            ImporteComision + "/" +
            await TratamientoDeParametroParaURI(Cuenta) + "/" +
            await TratamientoDeParametroParaURI(CUIT) + "/" +
            await TratamientoDeParametroParaURI(Direccion) + "/" +
            await TratamientoDeParametroParaURI(RazonSocial) + "/" +
            await TratamientoDeParametroParaURI(DomicilioPago) + "/" +
            await TratamientoDeParametroParaURI(RazonSocial_Origen) + "/" +
            await TratamientoDeParametroParaURI(FechaAdjudicacion) + "/" +
            await TratamientoDeParametroParaURI(AdjudicacionDestino) + "/" +
            await TratamientoDeParametroParaURI(AdjudicacionReferencia));
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_CON_Cheques_Adjudicar = async (IdCheque, Fecha, Destino, Referencia) => {
    const NombreFuncion = "function_CON_Cheques_Adjudicar";

    try {
        await llamadaAPI_PUT("CON_Cheques/Adjudicar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdCheque + "/" +
            await FormateoFechaPara_yyyyMMdd(new Date(Fecha)) + "/" +
            await TratamientoDeParametroParaURI(Destino) + "/" +
            await TratamientoDeParametroParaURI(Referencia));
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_CON_Cheques_Leer = async (IdCheque) => {
    const NombreFuncion = "function_CON_Cheques_Leer"

    try {
        const resulData = await llamadaAPI_GET("CON_Cheques/Leer/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdCheque);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CON_Cheques_Generar_JSON = async (CodigoCompania, IdPago, IdRecibo, CodigoCuentaFinancieraOrigen,
    CodigoCuentaFinancieraDeposito, Numero,
    FechaEmision, FechaPagoCompromiso, FechaDeposito, FechaCobro, FechaRechazo, Banco, Importe, IdEstado,
    ImporteCobrado, ImporteComision, Cuenta, CUIT, Direccion, RazonSocial, DomicilioPago,
    RazonSocial_Origen, FechaAdjudicacion, AdjudicacionDestino, AdjudicacionReferencia) => {
    const NombreFuncion = "function_CON_OperacionesParaImportar_Generar_JSON";

    try {

        const JSON = {
            CodigoCompania: CodigoCompania,
            IdPago: IdPago,
            IdEstado: IdEstado,
            IdRecibo: IdRecibo,
            CodigoCuentaFinancieraOrigen: CodigoCuentaFinancieraOrigen,
            CodigoCuentaFinancieraDeposito: CodigoCuentaFinancieraDeposito,
            Numero: Numero,
            FechaEmision: FechaEmision,
            FechaPagoCompromiso: FechaPagoCompromiso,
            FechaDeposito: FechaDeposito,
            FechaCobro: FechaCobro,
            FechaRechazo: FechaRechazo,
            Banco: Banco,
            Importe: Importe,
            ImporteCobrado: ImporteCobrado,
            ImporteComision: ImporteComision,
            Cuenta: Cuenta,
            CUIT: CUIT,
            Direccion: Direccion,
            RazonSocial: RazonSocial,
            DomicilioPago: DomicilioPago,
            RazonSocial_Origen: RazonSocial_Origen,
            FechaAdjudicacion: FechaAdjudicacion,
            AdjudicacionDestino: AdjudicacionDestino,
            AdjudicacionReferencia: AdjudicacionReferencia
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_CON_Cheques_Insertar = async (Operacion) => {
    const NombreFuncion = "function_CON_Cheques_Insertar";

    try {
        const operacionResult = await llamadaAPI_POST("CON_Cheques/Insertar/",
            Operacion);
        return operacionResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};